import { combineReducers } from 'redux';
import fieldReducer from './fieldReducer';
import accountReducer from './entities/accountReducer';
import bulkEditReducer from './entities/bulkEditReducer';
import moveEntityReducer from './entities/moveEntityReducer';
import organizationReducer from './entities/organizationReducer';
import entityPartialListReducer from './entities/entityPartialListReducer';
import pipelineReducer from './entities/pipelineReducer';
import contactReducer from './entities/contactReducer';
import segmentReducer from './segmentReducer';
import tableColumnReducer from './tableColumnReducer';
import fieldMappingReducer from './fieldMappingReducer';
// eslint-disable-next-line no-unused-vars
import fieldPinReducer from './fieldPinReducer';
import entityActionReducer from './entities/entityActionReducer';
import entityActivityReducer from './entities/entityActivityReducer';
import authReducer from './authReducer';
import userReducer from './userReducer';
import imageUploadReducer from './imageUploadReducer';
import fileUploadReducer from './fileUploadReducer';
import currentUserReducer from './currentUserReducer';
import currencyReducer from './currencyReducer';
import systemFieldsReducer from './systemFieldsReducer';
import lifecyclesReducer from './lifecyclesReducer';
import summaryCollapseStatusReducer from './summaryCollapseStatusReducer';
import healthReducer from './healthReducer';
import zendeskeReducer from './integrations/zendeskReducer';
import integrationSetupReducer from './integrations/integrationSetupReducer';
import notificationReducer from './notificationReducer';
import statBarReducer from './statBarReducer';
import reportingReducer from './reportingReducer';
import appbarReducer from './appbarReducer';
import gmailReducer from './integrations/gmailReducer';
import gmailV3Reducer from './integrations/gmailV3Reducer';
import emailsReducer from './emailsReducer';
import taskReducer from './tasksAndPlaybooks/taskReducer';
import taskBoardReducer from './tasksAndPlaybooks/taskBoardReducer';
import playbookTemplatesReducer from './tasksAndPlaybooks/playbookTemplateReducer';
import ticketReducer from './ticketReducer';
import playbookInstanceReducer from './tasksAndPlaybooks/playbookInstanceReducer';
import scenarioCanvasReducer from './scenarioReducers/scenarioCanvasReducer';
import scenariosReducer from './scenarioReducers/scenarioReducer';
import crmDataMappingReducer from './integrations/crmIntegrations/crmDataMappingReducer';
import notificationConfigurationReducer from './notificationConfigurationReducer';
import webhookReducer from './webhookReducer';
import activityTypeReducer from './activityTypeReducer';
import exportDataReducer from './exportDataReducer';
import crmConditionReducer from './integrations/crmIntegrations/crmConditionReducer';
import crmConfigNavigationReducer from './integrations/crmIntegrations/crmConfigNavigationReducer';
import crmPropertyReducer from './integrations/crmIntegrations/crmPropertyReducer';
import crmFilterReducer from './integrations/crmIntegrations/crmFilterReducer';
import surveyReducer from './surveyReducer';
import googleCalendarReducer from './integrations/googleCalendarReducer';
import healthBreakdownReducer from './healthBreakdownReducer';
import successPlanReducer from './successPlanReducer';
import successPlanReducerV2 from './successPlanReducerV2';
import successPlanMilestoneReducer from './successPlanMilestoneReducer';
import successPlanMilestoneReducerV2 from './successPlanMilestoneReducerV2';
import successPlanKPIReducer from './successPlanKPIReducer';
import successPlanKPIReducerV2 from './successPlanKPIReducerV2';

import successPlanFilesReducer from './successPlanFilesReducer';
import successPlanFilesReducerV2 from './successPlanFilesReducerV2';

import crmNoteSyncReducer from './integrations/crmIntegrations/crmNoteSyncReducer';
import crmParentLinkReducer from './integrations/crmIntegrations/crmParentLinkReducer';
import intercomNavigationReducer from './integrations/supportIntegrations/intercomNavigationReducer';
import vendorPropertyReducer from './integrations/supportIntegrations/vendorPropertyReducer';
import ticketFieldMappingReducer from './integrations/supportIntegrations/ticketFieldMappingReducer';
import zendeskPropertyReducer from './integrations/zendeskPropertyReducer';
import cockpitReducer from './cockpitReducer';
import calendarReducer from './integrations/calendarReducer';
import filteredViewsReducer from './filteredViewsReducer';
import slackReducer from './slackReducer';
import teamsReducer from './teamsReducer';
import allSuccessPlanReducer from './allSuccessPlansReducer';
import conversationReducer from './conversationReducer';
import crmConfigStatusReducer from './integrations/crmIntegrations/crmConfigStatusReducer';
import emailTemplateReducer from './emailTemplateReducer';
import emailCampaignReducer from './emailCampaignReducer';
import entityChangeLogReducer from './entities/entityChangeLogReducer';
import unsubscriptionReducer from './unsubscriptionReducer';
import workSpaceReducer from './workSpaceReducer';
import viceReducer from './viceReducer';
import crmActivitySyncReducer from './integrations/crmIntegrations/crmActivitySyncReducer';
import outlookCalendarReducer from './integrations/outlookCalendarReducer';
import velarisAiReducer from './velarisAiReducer';
import crmParentCreateReducer from './integrations/crmIntegrations/crmParentCreateReducer';
import emailSignatureReducer from './emailSignatureReducer';
import communicationPropertyReducer from './integrations/communicationIntegrations/communicationPropertyReducer';
import communicationUserMappingReducer from './integrations/communicationIntegrations/communicationUserMappingReducer';
import eventConfigReducer from './integrations/eventConfigReducer';
import globalPreSetReducer from './globalConfigReducer';
import crmDeduplicationUpdateReducer from './integrations/crmIntegrations/crmDeduplicationUpdateReducer';
import integrationContextStatusReducer from './integrations/supportIntegrations/integrationContextStatusReducer';
import successPlanTemplateKpiReducer from './successplanTemplates/successPlanTemplateKpiReducer';
import customObjectReducer from './customObjectReducer';
import successPlanTemplateMilestoneReducer from './successplanTemplates/successPlanTemplateMilestoneReducer';
import crmAdditionalDeduplication from './integrations/crmIntegrations/crmAdditionalDeduplicationReducer';
import crmSyncDataReducer from './integrations/crmIntegrations/crmSyncDataReducer';

// need to be reviewed
export default combineReducers({
  fields: fieldReducer,
  entityBulkEdit: bulkEditReducer,
  organizations: organizationReducer,
  accounts: accountReducer,
  contacts: contactReducer,
  pipelines: pipelineReducer,
  tableColumns: tableColumnReducer,
  segments: segmentReducer,
  fieldMappings: fieldMappingReducer,
  // emails: emailAuthReducer,
  emails: emailsReducer,
  fieldPin: fieldPinReducer,
  entityAction: entityActionReducer,
  entityActivity: entityActivityReducer,
  auth: authReducer,
  imageUpload: imageUploadReducer,
  fileUpload: fileUploadReducer,
  userManagement: userReducer,
  userEmailSignature: emailSignatureReducer,
  currentUser: currentUserReducer,
  currency: currencyReducer,
  systemFieldConfig: systemFieldsReducer,
  lifecycles: lifecyclesReducer,
  summaryCollapseStatus: summaryCollapseStatusReducer,
  health: healthReducer,
  healthBreakdown: healthBreakdownReducer,
  moveEntity: moveEntityReducer,
  zendesk: zendeskeReducer,
  gmail: gmailReducer,
  gmailV3: gmailV3Reducer,
  googleCalendar: googleCalendarReducer,
  integrationSetup: integrationSetupReducer,
  notifications: notificationReducer,
  statBar: statBarReducer,
  reportings: reportingReducer,
  appbar: appbarReducer,
  tasks: taskReducer,
  taskBoard: taskBoardReducer,
  playbookTemplates: playbookTemplatesReducer,
  tickets: ticketReducer,
  playbookInstances: playbookInstanceReducer,
  entityPartialList: entityPartialListReducer,
  scenarioCanvas: scenarioCanvasReducer,
  scenarios: scenariosReducer,
  crmDataMapping: crmDataMappingReducer,
  crmCondition: crmConditionReducer,
  crmProperty: crmPropertyReducer,
  crmConfigNavigation: crmConfigNavigationReducer,
  crmParentLink: crmParentLinkReducer,
  crmParentLinkCreate: crmParentCreateReducer,
  notificationConfiguration: notificationConfigurationReducer,
  webhooks: webhookReducer,
  activityTypes: activityTypeReducer,
  exportData: exportDataReducer,
  crmInSyncFilter: crmFilterReducer,
  surveys: surveyReducer,
  successPlans: successPlanReducer,
  successPlansV2: successPlanReducerV2,
  milestonesV2: successPlanMilestoneReducerV2,
  milestones: successPlanMilestoneReducer,
  kpis: successPlanKPIReducer,
  kpisV2: successPlanKPIReducerV2,
  successPlanFiles: successPlanFilesReducer,
  successPlanFilesV2: successPlanFilesReducerV2,
  crmNoteSync: crmNoteSyncReducer,
  intercomNavigation: intercomNavigationReducer,
  vendorProperty: vendorPropertyReducer,
  ticketMapping: ticketFieldMappingReducer,
  zendeskProperty: zendeskPropertyReducer,
  cockpit: cockpitReducer,
  calendar: calendarReducer,
  views: filteredViewsReducer,
  slackMessage: slackReducer,
  allSuccessPlans: allSuccessPlanReducer,
  conversations: conversationReducer,
  crmConfigStatus: crmConfigStatusReducer,
  emailTemplate: emailTemplateReducer,
  emailCampaign: emailCampaignReducer,
  entityChangeLogs: entityChangeLogReducer,
  unsubscription: unsubscriptionReducer,
  workSpace: workSpaceReducer,
  vice: viceReducer,
  crmActivity: crmActivitySyncReducer,
  outlookCalendar: outlookCalendarReducer,
  velarisAi: velarisAiReducer,
  communicationProperty: communicationPropertyReducer,
  communicationUserMapping: communicationUserMappingReducer,
  teams: teamsReducer,
  eventConfig: eventConfigReducer,
  globalConfigs: globalPreSetReducer,
  crmDeduplicationUpdate: crmDeduplicationUpdateReducer,
  integrationContextStatus: integrationContextStatusReducer,
  kpiTemplates: successPlanTemplateKpiReducer,
  customObject: customObjectReducer,
  milestoneTemplates: successPlanTemplateMilestoneReducer,
  additionalDeduplication: crmAdditionalDeduplication,
  crmSyncData: crmSyncDataReducer,
});
